import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Activity } from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ActivitiesPipesModule } from '@wilson/activities/pipes';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons';
import { ShiftMultiSelectHelperService } from '@wilson/shift-timeline/assignments-gantt-chart';
import { ShiftOperationsService } from '@wilson/non-domain-specific/shift-helpers/core';
import { SetDemarcatorRange } from '@wilson/shift-timeline/state';

@Component({
  selector: 'wilson-shift-form-edit-button',
  templateUrl: './shift-form-edit-button.component.html',
  styleUrls: ['./shift-form-edit-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    NzButtonModule,
    ActivitiesPipesModule,
    FontAwesomeModule,
  ],
})
export class ShiftFormEditButtonComponent {
  private readonly shiftOperationsService = inject(ShiftOperationsService);
  private readonly store = inject(Store);
  private readonly shiftMultiSelectHelperService = inject(
    ShiftMultiSelectHelperService,
  );

  readonly faPenToSquare = faPenToSquare;

  @Input({ required: true }) shiftId?: string = undefined;
  @Input({ required: true }) isFormPristine = false;
  @Input({ required: true }) activities!: Activity[];
  @Input() disabled = false;

  protected editShift(): void {
    if (this.shiftId) {
      const route = `/shifts/${this.shiftId}/edit`;
      if (!this.isFormPristine) {
        this.shiftOperationsService.confirmNavigateAway(() => {
          window.open(route, '_blank');
          this.shiftMultiSelectHelperService.clearSelection();
          this.store.dispatch([new SetDemarcatorRange([])]);
        });
      } else {
        window.open(route, '_blank');
      }
    }
  }
}
